import { storesReducer } from "./stores.reducer";
import { brandReportReducer } from "./brandReport.reducer";
import { performanceReducer } from "./performance.reducer";
import { activityLogsReducer } from "./activityLogs.reducer";
import { surveyQueuesReducer } from "./surveyQueues.reducer";
import { googleSocialLinkReducer } from "./googleSocialLink.reducer";
import { mergeDuplicateStoresReducer } from "./mergeDuplicateStores.reducer";
import { featureFlagsReducer } from "./featureFlags.reducer";
import { aiReplyReducer } from "./aiReply.reducer";

// eslint-disable-next-line
export default {
  storesReducer,
  brandReportReducer,
  aiReplyReducer,
  performanceReducer,
  activityLogsReducer,
  surveyQueuesReducer,
  mergeDuplicateStoresReducer,
  googleSocialLinkReducer,
  featureFlagsReducer,
};
